interface SectionProps {
  splitCards?: any[];
  cards?: any[];
  tabs?: any[];
  sections?: any[];
  buckets: any[];
}

// This return the collection of card type object of funds - Top Plans or Top funds
export const getPlanCards = (
  sectionsList: SectionProps[],
  buckets: any[],
  bucketOrder?: any[]
) => {
  const cardsObj = {};

  const updateCartObj = (list: any[], noTypeCheck: boolean = false) => {
    list.forEach((item) => {
      if (item.type === 'plan' || noTypeCheck) {
        cardsObj[item.bucketId] = {
          data: buckets.filter(
            (bucket) => bucket.bucketId === item.bucketId
          )[0],
        };
      }
    });
  };
  sectionsList.forEach((section: SectionProps) => {
    const { cards = [], splitCards = [], sections = [] } = section;
    updateCartObj(splitCards);

    updateCartObj(cards, true);

    sections.forEach((eachSection) => {
      const { tabs = [] } = eachSection || {};
      tabs.forEach((tab) => {
        const { splitCards: tabSplitCards = [] } = tab || {};
        updateCartObj(tabSplitCards);
      });
    });
  });
  const bucketOrderList = bucketOrder || [19, 26, 25, 20, 21, 22];
  const cardsList = [];
  for (const bucketItem of bucketOrderList) {
    cardsList.push(cardsObj[bucketItem]);
  }
  return cardsList;
};



// WEBPACK FOOTER //
// ./utils/planCard.ts